import { Modal } from "antd"
import ReactPlayer from "react-player"
import { useSelector } from "react-redux"

import Icon from "../../Icon"

const VideoPlayerModal = ({ videoUrl, isOpened, close }) => {
  const { isMobile } = useSelector((state) => state.nav)
  return (
    <Modal
      getContainer={() => document.getElementById("main-layout")}
      classNames={{ wrapper: "video-modal", content: "clear-bg" }}
      {...(isMobile ? { transitionName: "" } : null)}
      open={isOpened}
      centered={!isMobile}
      closeIcon={<Icon type="close_modal" />}
      footer={null}
      closable={true}
      onCancel={close}
      destroyOnClose
    >
      <ReactPlayer controls={true} width={"100%"} height={"100%"} playing={true} url={videoUrl} />
    </Modal>
  )
}

export default VideoPlayerModal
